<template>
     <div style="width:1300px;margin:0 auto;">
            <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
                <p class="text-center mb-2">
                     <span style="font-size:15px;">
                       回复信息
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>                   
                                     <p class="mb-2" style="font-size:15px;">
                                         <span>
                                             标题:
                                         </span>
                                         <span>
                                           {{title}}
                                         </span>
                                     </p>
                                     <div class="mb-2">
                                         <span>
                                           内容:
                                         </span>
                                         <div v-html="contents">
                                           {{contents}}
                                         </div>
                                     </div>
                                     <div>
                                        <!-- <span>
                                          图片:
                                        </span>
                                        <div class="mb-1">
                                                <img style="width:50px;height:50px;" :src="'http://fw.hyey.cn'+image1" alt="">
                                                <img style="width:50px;height:50px;" :src="'http://fw.hyey.cn'+image2" alt="">
                                                <img style="width:50px;height:50px;" :src="'http://fw.hyey.cn'+image3" alt="">
                                                <img style="width:50px;height:50px;" :src="'http://fw.hyey.cn'+image4" alt="">
                                                <img style="width:50px;height:50px;" :src="'http://fw.hyey.cn'+image5" alt="">
                                        </div> -->
                                     </div>
                                    
                                     <div>
                                            <quill-editor ref="myTextEditor" v-model="content" :options="editorOption" style="height:400px;">
                                            </quill-editor>
                                     </div>

                                      
                                         <table></table>
                                     <div class="mt-5">
                                        <span style="font-size:15px;">
                                            回复图片:
                                        </span>
                                     </div>
                                        <div class="form-group">
                                          <div class="control-form">
                                            <!-- <p class="help-block">(建议图片格式为：JPEG/BMP/PNG/GIF，大小不超过5M，最多可上传5张)</p> -->
                                            <ul class="upload-imgs">
                                              <li v-for='(value, index) in imgdata' :key="index">
                                                <p class="img"><img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+value" alt="未上传图片"><a class="close" @click="delImg(index)">×</a></p>
                                              </li>
                                              <li v-if="imgdata.length>=5 ? false : true">
                                                <input style="display:none" type="file" id="file" class="upload" @change="addImg()" ref="inputer" multiple accept="image/png,image/jpeg,image/gif,image/jpg"/>
                                                <img @click="fileBtn()" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                              </li>
                                            </ul>
                                          </div>
                                        </div>



                                         <div>
                                            <span style="font-size:15px;">
                                                上传文件:
                                            </span>
                                        </div>
                                         <div class="form-group">
                                          <!-- <label class="control-label">上传图片</label> -->
                                          <div class="control-form">
                                            <p class="help-block">(建议文件格式为:doc, xls, ppt, pdf, docx, xlsx, pptx,最多可以上传十个文件)</p>
                                            <ul class="upload-imgs">
                                              <li v-for='(value, index) in wendata' :key="index">
                                                <p class="wen">
                                                   <span style="color:red;">附件</span>
                                                   <span style="color:red;">{{index+1}}</span>
                                                  <a class="close" @click="delImg1(index)">×</a></p>
                                                  <span style="color:blue;">
                                                    {{value | changeValue}}
                                                  </span>
                                              </li>
                                              <li v-if="wendata.length>=10 ? false : true">
                                                <input style="display:none" type="file" id="file1" class="upload" @change="addImg1()" ref="inputer" multiple accept=".doc,.xls,.ppt,.docx,.xlsx,.pptx"/>
                                                <!-- <a class="add"><i class="iconfont icon-plus"></i><p>点击上传</p></a> -->
                                                <img @click="fileBtn1()" style="width:100px;height:100px;" src="../../../static/images/jia.png" alt="">
                                              </li>
                                            </ul>
                                          </div>
                                        </div>





                                       
 


                                      <p class="text-center mt-5">
                                                <button class="btn btn-primary" @click="modificationBlog()" :disabled="isDisable">回复</button>
                                      </p>
            </div> 
     </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
     data(){
          return{
              BlogList:[],
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              content: '',
              contents:'',
               editorOption: {
               placeholder: '回复内容',
                modules:{
                        toolbar:[
                           ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                        ]
                    },
             },
             title:'',
             author:'',
            currentTime:'',
               imgdata:[],
              imgdata1:[],
               imgs:"",
             isDisable:false,

              wendata:[],
              wendata1:[],
              wens:"",

            fileurl:[],

          }
      },
      filters: {
  
       changeValue(value){
            
             return  value.slice(33)

       }
     
         },

        components: {
             quillEditor
        },
      methods:{
    getNowTime() {
		let date = new Date();
    this.year = date.getFullYear();
    this.getMonth1=date.getMonth() + 1
		this.month = date.getMonth() + 1 < 10 ? "0" + this.getMonth1 : date.getMonth() + 1;
		this.date = date.getDate();
		this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
		this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
		this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		this.milliSeconds = date.getMilliseconds();
		let currentTime = this.year+'-'+this.month + '-' + this.date + ' ' + this.hour + ':' + this.minute + ':' + this.second;
        // console.log(currentTime);
        this.title=currentTime;
	},
       onEditorChange({ editor, html, text }) {
            this.content = html;
        }, 
       


                 //上传文件
      async addImg1(){
          let that=this;
          let file = event.target.files[0]; //获取input的图片file值
          // console.log(file)

          let param = new FormData(); // 创建form对象
          
          param.append("imgFile", file);
          param.append("username",window.sessionStorage.getItem('username')); 
          param.append("tokenid",window.sessionStorage.getItem('tokenid')); 
          param.append("phone_uuid","");
          await that.$http.post('Dls/UpLoadFile', param).then(res => {
               that.alertShow=true;
              // console.log(res)
            if(res.data.isok){
              // that.IMG_URL(res.data.data);
              if(that.wendata.length<=10){
              that.wendata.push(res.data.data);
              // console.log(that.wendata)
              that.$message.success("操作成功!")
            }
            else{
              alert("最多只能传入十个文件")
            }
            }
            else{
              alert(res.data.message)
            }
        });
      },


          //上传日志图片
      async addImg(){
          let that=this;
          let file = event.target.files[0]; //获取input的图片file值
          let param = new FormData(); // 创建form对象
          param.append("imgFile", file);
          param.append("username",window.sessionStorage.getItem('username')); 
          param.append("tokenid",window.sessionStorage.getItem('tokenid')); 
          param.append("phone_uuid","");
          await that.$http.post('Dls/UpLoadImage', param).then(res => {
                that.alertShow=true;
            if(res.data.isok){
              // console.log(res)
              // that.IMG_URL(res.data.data);
              if(that.imgdata.length<=4){
              that.imgdata.push(res.data.data);
              that.$message.success("操作成功!")
            }
            else{
              alert("最多只能传入五张图片")
            }
            }
            else{
              that.$message.success(res.data.message)
            }
        });
      },
       fileBtn1(){
          document.getElementById('file1').click();
          let file = document.getElementById('file1');
            //  console.log(file.value);
       },
       fileBtn(){
          document.getElementById('file').click();
            let file = document.getElementById('file');
            //  console.log(file.value);
       },
         delImg1(index){
        this.wendata.splice(index,1);
        //  console.log(this.imgdata);
      },
         delImg(index){
        this.imgdata.splice(index,1);
        //  console.log(this.imgdata);
      },


         //查看日志
       lookBlog:async function(){
              // this.getNowTime()
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkLookBlog',
          obj: JSON.stringify({
                username:window.sessionStorage.getItem("username"),
                lxs:'1',
                state:'0',
                id:this.id,
          })
        })
        //  console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  const obj = res.data;
                  this.title=obj.rows[0].title;
                  // console.log(this.title)
                  this.fileurl=obj.rows[0].fileurl.split(",")
                  this.fileurl.forEach((item,index)=>{
                 if(item!=""){
                      this.wendata.push(this.fileurl[index])
                           }
                        })
                  this.contents=obj.rows[0].contents;
                  this.author = obj.rows[0].truename;
              if(obj.rows[0].image1!=""&&obj.rows[0].image1!=null){
                    this.imgdata.push(obj.rows[0].image1);
                }
              if(obj.rows[0].image2!=""&&obj.rows[0].image2!=null){
                        this.imgdata.push(obj.rows[0].image2);
                    }
              if(obj.rows[0].image3!=""&&obj.rows[0].image3!=null){
                        this.imgdata.push(obj.rows[0].image3);
                    }
              if(obj.rows[0].image4!=""&&obj.rows[0].image4!=null){
                        this.imgdata.push(obj.rows[0].image4);
                    }
              if(obj.rows[0].image5!=""&&obj.rows[0].image5!=null){
                        this.imgdata.push(obj.rows[0].image5);
                    }


                
             }
        }
       },


        //回复日志
       modificationBlog:async function(){
               const that = this
               that.isDisable=true
              that.imgdata1=[...that.imgdata]
              if(that.imgdata1.length<5){
                
                    for(let i=0;i<9-that.imgdata1.length;i++){
                           that.imgdata1.push("")
                    }
              }
            that.imgs=that.imgdata1.toString()
             that.wendata1=[...that.wendata]
              if(that.wendata1.length<10){
                
                    for(let i=0;i<19-that.wendata1.length;i++){
                           that.wendata1.push("")
                    }
              }
            that.wens=that.wendata1.toString()
            if(that.content==""&&that.imgs.length<5){
                 alert("回复内容不为空")
                  that.isDisable=false
            }
            else{
              const { data: res } = await that.$http.post('Dls/getFun', {
            action: 'ClerkUpBlog',
            obj: JSON.stringify({
                  // username:'kzy001',
                  lxs:'5',
                  state:'1',
                  id:that.id,
                  reply:that.content,
                  img:that.imgs,
                  fileurl:that.wens
            })
          })
          // console.log(res)
          if (res.isok) {
              if(res.data.isok){
                that.$message.success(res.data.msg)
                that.$router.go(-1)
                that.isDisable=false
                const obj = res.data;
              }
              else{
                that.$message.success(res.data.msg)
                that.isDisable=false
              }
          }

            }
       },

      },
      mounted(){

      },
      created(){
          this.id=this.$route.query.id;
        //   this.getNowTime();
        this.lookBlog()
      }

}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
.input_form-control { 
// display: block; 
width: 20%; 
height: 34px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
} 
.upload-imgs{
  margin: 5px 0 10px 0;
  overflow: hidden;
  font-size: 0;
  }

.upload-imgs li{
  position: relative;
  width: 109px;
  height: 109px;
  font-size: 14px;
  display: inline-block;
  padding: 3px;
  margin-right: 10px;
  border: 1.4px dashed #ccc;
  text-align: center;
  vertical-align: middle;}
.upload-imgs li:hover{
    border: 1.4px dashed #36d;
  }
.upload-imgs .add{
  display: block;
  background-color: #ccc;
  color: #ffffff;
  height: 94px;
  padding: 8px 0;
  }
.upload-imgs .add .iconfont{padding: 10px 0;font-size: 40px;}
.upload-imgs li:hover .add{background-color: "#36d";}
.upload-imgs li .upload{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 109px;
  height: 109px;}
.upload-imgs .img{
  position: relative;
  width: 94px;height: 94px;line-height: 94px;}
.upload-imgs .img img{vertical-align: middle;}
.upload-imgs .img .close{display: none;}
.upload-imgs li:hover .img .close{display: block;position: absolute;right: -6px;top: -10px;line-height: 1;font-size: 22px;color: #36d;}


</style>




// WEBPACK FOOTER //
// src/pages/MyLog/Revert.vue